module.exports = __webpack_public_path__ + "src/images/javascript-logo.076eea1cf72da9607b58463121908ae6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/javascript-logo.svg
// module id = 96
// module chunks = 0